import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, HeadphonesIcon, PresentationIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen w-full overflow-hidden" data-id="element-56">
      {/* Neutral Dark Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#1a1a1a] to-[#0a0a0a]" data-id="element-57">
        {/* Venezuelan flag texture - very subtle */}
        <div className="absolute inset-0 opacity-[0.08]" style={{
        backgroundImage: 'url(https://upload.wikimedia.org/wikipedia/commons/0/06/Flag_of_Venezuela.svg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        filter: 'blur(40px) grayscale(30%)'
      }} data-id="element-58" />

        {/* Subtle texture overlay */}
        <div className="absolute inset-0 opacity-30" style={{
        backgroundImage: 'radial-gradient(circle at 20% 50%, rgba(212, 175, 55, 0.03) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(212, 175, 55, 0.03) 0%, transparent 50%)'
      }} data-id="element-59" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-20" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center max-w-4xl mx-auto" data-id="element-61">
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="text-[#D4AF37] uppercase tracking-[0.3em] text-sm mb-6 font-medium" data-id="element-62">
            Colección "Protagonistas de Nuestro Tiempo"
          </motion.p>

          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-8" data-id="element-63">
            <span className="text-white" data-id="element-64">
              La Colección Definitiva para Comprender a{' '}
            </span>
            <span className="text-[#D4AF37]" data-id="element-65">
              Diosdado Cabello, Delcy Rodríguez y Leopoldo López
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-66">
            Tres eBooks con sus respectivos audiolibros y presentaciones
            visuales. Un enfoque neutro, histórico y educativo sobre tres
            figuras clave de Venezuela.
          </p>

          {/* Format Icons */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex justify-center gap-8 md:gap-16 mb-16" data-id="element-67">
            {[{
            icon: PresentationIcon,
            label: 'Presentación'
          }, {
            icon: BookOpenIcon,
            label: 'eBook'
          }, {
            icon: HeadphonesIcon,
            label: 'Audio'
          }].map((item, index) => <motion.div key={item.label} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.7 + index * 0.1
          }} className="flex flex-col items-center gap-3" data-id="element-68">
                <div className="w-16 h-16 rounded-full bg-[#D4AF37]/10 flex items-center justify-center" data-id="element-69">
                  <item.icon className="w-8 h-8 text-[#D4AF37]" data-id="element-70" />
                </div>
                <span className="text-sm text-gray-400 font-medium" data-id="element-71">
                  {item.label}
                </span>
              </motion.div>)}
          </motion.div>

          {/* CTA Button */}
          <motion.a href="#cta-button" initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 1
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} onClick={e => {
          e.preventDefault();
          document.getElementById('cta-button')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }} className="inline-block bg-[#D4AF37] text-black font-bold px-10 py-5 text-lg rounded-sm hover:bg-[#E5C158] transition-colors shadow-lg shadow-[#D4AF37]/20" data-id="element-72">
            Ver la Colección Completa
          </motion.a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2" data-id="element-73">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} className="w-6 h-10 border-2 border-gray-600 rounded-full flex justify-center pt-2" data-id="element-74">
          <div className="w-1.5 h-3 bg-[#D4AF37] rounded-full" data-id="element-75" />
        </motion.div>
      </motion.div>
    </section>;
}